import { useStore } from '../helpers';

export const useProjectID = () => {
  const store = useStore();
  return store.projectId;
};
